import React from "react"
import PropTypes from "prop-types"
import "./SearchBar.css"
import { MagnifierIcon } from "../../Icons"

class SearchBar extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      value: ""
    }
  }
  handleKeyDown = e => {
    e.key === "Enter" && this.props.onEnter()
  }
  handleChange = e => {
    this.props.handleChange(e.target.value)
  }
  handleBlur = () => {
    this.props.onBlur && this.props.onBlur()
  }
  render() {
    return (
      <div className="SearchBar">
        <input
          type="text"
          placeholder={this.props.placeholder}
          onKeyDown={this.handleKeyDown}
          value={this.props.value}
          onChange={this.handleChange}
          onBlur={this.handleBlur}
        />
        <button>
          <MagnifierIcon />
        </button>
      </div>
    )
  }
}

SearchBar.propTypes = {
  placeholder: PropTypes.string,
  onEnter: PropTypes.func.isRequired
}

SearchBar.defaultProps = {
  placeholder: "Search keywords",
  onEnter: keyword => {
    console.log(keyword)
  }
}

export default SearchBar
